<template>
  <div>
    <BaseTitle :title="$t(edit ? 'content.edit_template' : 'content.add_template')" />
    <v-row>
      <v-col cols="12" md="12">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-6">
              <form-group :name="$t('content.template_name')" :validator="$v.form.templateName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.templateName"
                    v-bind="attrs"
                    :label="$t('content.template_name')"
                    @input="$v.form.templateName.$touch()"
                    @blur="$v.form.templateName.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>

          <v-btn color="primary" class="btn-primary-custom mb-5 mb-md-0 mr-md-2" v-if="modeCategory === false" @click="modeCategory = true">{{
            $t('content.add_category')
          }}</v-btn>
          <!-- category add/edit -->
          <v-card class="mb-8" v-if="modeCategory === true">
            <div class="pa-6">
              <form-group :name="$t('content.category_name')" :validator="$v.formTemp.categories">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-model="formTemp.categories"
                    v-bind="attrs"
                    :items="listCategory"
                    item-text="categoryName"
                    item-value="analyticalCategoryId"
                    @change="categoriesChange($event)"
                    :label="$t('content.category_name')"
                    @input="$v.formTemp.categories.$touch()"
                    @blur="$v.formTemp.categories.$touch()"
                  />
                </template>
              </form-group>
              <div class="d-flex justify-end align-center">
                <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closeCategory">{{ $t('cancel') }}</v-btn>
                <v-btn color="primary" class="btn-primary-custom" @click="pushCategory">
                  {{ $t('submit') }}
                </v-btn>
              </div>
            </div>
          </v-card>
          <v-divider class="mt-8" v-if="modeCategory === false" />
          <!-- list category -->
          <template v-if="modeCategory === false">
            <v-card class="mb-8 mt-8" v-for="(data, index) in form.categories" :key="index">
              <div class="pa-5">
                <v-row class="border-item">
                  <v-col md="10">
                    <div class="d-block">
                      <h3 class="d-inline">
                        <span class="header-content"> {{ $t('content.category_name') }} </span>
                      </h3>
                    </div>
                    <div class="d-block">
                      <div>
                        <span class="body-content">
                          <span>
                            {{ data.categoryName }}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="d-flex"></div>
                  </v-col>
                  <v-col md="2">
                    <div class="d-inline d-flex">
                      <v-btn text @click="editItemCategory(data, index)"><svg-icon icon="edit" small class="primary--text"/></v-btn>
                      <v-btn text @click="dialogDeleteCategories = true" class="mr-1"><svg-icon icon="delete" small class="red--text"/></v-btn>
                      <!-- Dialog Delete Course -->
                      <v-dialog v-model="dialogDeleteCategories" persistent max-width="290">
                        <v-card>
                          <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                          <v-card-text>{{ $t('delete_message') }}</v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn text @click="dialogDeleteCategories = false">{{ $t('disagree') }}</v-btn>
                            <v-btn text :loading="loading" @click="deleteItemCategories(data, index)">{{ $t('aggree') }}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </template>

          <div class="d-flex justify-end align-center mt-8" v-if="modeCategory === false">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/Title';
import { maxLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
export default {
  name: 'CreateEditTemplateTeacher',
  components: {
    BaseTitle
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    }
  },
  validations() {
    return {
      form: {
        categories: { required },
        templateName: { required, maxLength: maxLength(30) }
      },
      formTemp: {
        categories: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      tokenBearer: 'Auth/token',
      user: 'Auth/user'
    })
  },
  data: () => ({
    form: {
      categories: [],
      templateName: ''
    },
    formTemp: {
      categories: '',
      objectCategories: {}
    },
    loadingButton: false,
    modeCategory: false,
    dialogDeleteCategories: false,
    listCategory: [],
    dataClass: '',
    loading: false,
    edit: false,
    indexEdit: '',
    editMode: false
  }),
  methods: {
    getData() {
      this.$store
        .dispatch(`Analytical/${this.type === 'teacher' ? 'getListTemplateById' : 'getListTemplateStudentById'}`, this.$route.params.idTemplate)
        .then(ras => {
          Object.keys(this.form).forEach(form => {
            this.form[form] = ras[form];
          });
        });
    },
    getListCategory() {
      this.loading = true;
      this.$store
        .dispatch(
          `Analytical/${this.type === 'teacher' ? 'getListCategoryTemplate' : 'getListCategoryTemplateStudent'}`,
          this.$route.params.idTemplate ? this.$route.params.idTemplate : ''
        )
        .then(data => (this.listCategory = data))
        .finally(() => (this.loading = false));
    },
    closeCategory() {
      this.modeCategory = false;
      this.formTemp.categories = '';
      this.formTemp.objectCategories = {};

      if (this.editMode) {
        let index = this.listCategory.findIndex(x => x.analyticalCategoryId === this.formTemp.objectCategories.analyticalCategoryId);
        this.listCategory.splice(index, 1);
      }
      this.$v.formTemp.$reset();
      this.editMode = false;
    },
    editItemCategory(data, index) {
      this.modeCategory = true;
      this.formTemp.objectCategories = data;
      this.formTemp.categories = data.analyticalCategoryId;
      this.listCategory.push({
        ...data
      });
      this.indexEdit = index;
      this.editMode = true;
    },
    deleteItemCategories(data, index) {
      this.form.categories.splice(index, 1);
      this.listCategory.push({
        ...data
      });
      this.dialogDeleteCategories = false;
    },
    pushCategory() {
      this.$v.formTemp.$touch();

      if (this.$v.formTemp.$invalid) {
        return false;
      }

      if (!this.editMode) {
        this.form.categories.push({
          ...this.formTemp.objectCategories
        });
      } else {
        this.form.categories[this.indexEdit] = null;
        this.form.categories[this.indexEdit] = this.formTemp.objectCategories;
      }

      let index = this.listCategory.findIndex(x => x.analyticalCategoryId === this.formTemp.objectCategories.analyticalCategoryId);
      this.listCategory.splice(index, 1);
      this.editMode = false;
      this.modeCategory = false;
      this.formTemp.categories = '';
      this.formTemp.objectCategories = {};
      this.$v.formTemp.$reset();
    },
    categoriesChange(id) {
      this.formTemp.objectCategories = this.listCategory.find(data => data.analyticalCategoryId === id);
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.idTemplate } : null), ...this.form };

      this.$store
        .dispatch(
          `Analytical/${
            this.edit && this.type === 'teacher'
              ? 'updateTemplate'
              : !this.edit && this.type === 'teacher'
              ? 'createTemplate'
              : this.edit && this.type === 'student'
              ? 'updateTemplateStudent'
              : 'createTemplateStudent'
          }`,
          payload
        )
        .then(() =>
          this.$router.push({
            name:
              this.edit && this.type === 'teacher'
                ? 'TemplateTeacherSuccessUpdate'
                : !this.edit && this.type === 'teacher'
                ? 'TemplateTeacherSuccess'
                : this.edit && this.type === 'student'
                ? 'TemplateStudentSuccessUpdate'
                : 'TemplateStudentSuccess'
          })
        )
        .finally(() => (this.loading = false));
    },
    back() {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'AnalyticTeacherListID', params: { idSidebar: 2 } });
      } else {
        this.$router.push({ name: 'AnalyticStudentListID', params: { idSidebar: 4 } });
      }
    }
  },
  created() {
    this.getListCategory();
    if (this.$route.params.idTemplate) {
      this.getData();
      this.edit = true;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 13px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
